import { PropTypes } from 'prop-types';

import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';
import Text from '@zenbusiness/zui/Text';

import ConstructorCallout from '#client/components/ConstructorCallout';
import { useCheckoutContext } from '#client/pages/Checkout/hooks/useCheckoutContext';

import AccountForm, { PasswordField } from './AccountForm';
import { CHECKOUT } from '../../../../constants';
import { CheckoutCard } from '../../../CheckoutCard';

function AccountCheckoutCard({ onContinue }) {
  const { formatMessage } = useIntl();
  const [{ password }, dispatch] = useCheckoutContext();

  const handleSubmit = (data) => {
    dispatch({
      type: CHECKOUT.ACTION.SET_PASSWORD,
      payload: data.password
    });
    onContinue();
  };

  return (
    <CheckoutCard step={CHECKOUT.STEP.ACCOUNT}>
      <CheckoutCard.Active>
        <Text size="sm">
          <FormattedMessage id="shopping.page.checkout.account.description" />
        </Text>
        <AccountForm defaultValues={{ password }} onSubmit={handleSubmit} />
        <ConstructorCallout
          description={formatMessage({
            id: 'shopping.page.checkout.callout.account.description'
          })}
        />{' '}
      </CheckoutCard.Active>
      <CheckoutCard.Complete>
        <PasswordField disabled readOnly value={password} variant="filled" />
      </CheckoutCard.Complete>
      <CheckoutCard.Incomplete />
    </CheckoutCard>
  );
}

AccountCheckoutCard.propTypes = {
  onContinue: PropTypes.func.isRequired
};

export default AccountCheckoutCard;
